<template>
<div>
    <v-xstarevm v-if="chainId == 9001"></v-xstarevm>
    <v-xstarevmtest v-if="chainId == 9000"></v-xstarevmtest>
    <v-xstarzk v-if="chainId == 280"></v-xstarzk>
    <v-xstarzkmain v-if="chainId == 324"></v-xstarzkmain>
    <v-xstarscroll v-if="chainId == 534353"></v-xstarscroll>
    <v-xstarscrollsepolia v-if="chainId == 534351"></v-xstarscrollsepolia>
</div>
</template>

<script>
    export default {
        data() {
            return {
                chainId:'',
            }
        },
        mounted(){
            this.chainId = localStorage.getItem('chainId') || 9001
        },
    }
</script> 